import {GridBookmark} from "../entities/GridBookmark";

export class GridBookmarkService {
    static $inject = ['localStorageService'];
    static KEY:string = "GRIDBOOKMARK.";
    constructor(public locStorage:angular.local.storage.ILocalStorageService) {
    }
    // Store a bookmark
    setBookmark(entityName:string, gridBookmark:GridBookmark) {
        if (entityName != null && entityName.length > 0) {
            var gridBookmarkJson = JSON.stringify(gridBookmark);
            this.locStorage.set(GridBookmarkService.KEY + entityName, gridBookmarkJson);
        }
    }
    // Recall a bookmark
    getBookmark(entityName:string):GridBookmark{
        if (entityName != null && entityName.length > 0) {
            var gridBookmarkJson: string = this.locStorage.get<string>(GridBookmarkService.KEY + entityName);
            if (gridBookmarkJson != null) {
                var gridBookmark: GridBookmark = JSON.parse(gridBookmarkJson);
                return gridBookmark;
            }
        }
        return null;
    }
    // Check whether a bookmark is recent
    static isRecent(gridBookmark:GridBookmark) {
        var diff_ms = Date.now() - gridBookmark.createDateMs;
        var diff_secs = diff_ms / 1000;
        return diff_secs < (10 * 60);
    }
}
